import "core-js/proposals/set-methods-v2";

const setIncludes = (
  set1: Set<string>,
  set2: Set<string>,
  includeAll = false,
) => {
  if (includeAll) {
    return set2.size > 0 && set1.isSupersetOf(set2);
  } else {
    return set1.intersection(set2).size > 0;
  }
};

export { setIncludes };
